import React, { Component } from 'react'
import {Accordion, Card} from 'react-bootstrap'
import Slide from 'react-reveal/Slide';

const styles={
    ppPerson: {
        'width': '70%',
        'height': '70%'
    }
}

export class ContentSection04 extends Component {
    render() {
        return (
            <section className="content-section-02" id="faq">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                            <div className="content-img">
                                <Slide bottom>
                                    <img src={require("../../assets/image/pp-icon-person.png")} style={styles.ppPerson} alt=''/>
                                </Slide>
                            </div>
                        </div>
                        <div className="col-xl-5  col-sm-6 order-sm-1">
                            <div className="content-left-content">
                            <h2>FAQ</h2>
                            <p> 
                                Frequently Asked Questions
                            </p>
                            <Accordion defaultActiveKey="0">
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="0">
                                        1. Apa itu Hackathon?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="0">
                                    <Card.Body>Hackathon adalah ajang berkumpul para developer dan penggemar teknologi untuk bersama-sama merancang solusi teknologi untuk memecahkan masalah tertentu. 
                                        Dalam hackathon, proses perancangan solusi ini diadakan dalam waktu yang singkat, biasanya 24-36 jam.</Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="1">
                                        2. Apa itu Digital Construction Hack ?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>Digital Construction Hack adalah acara kompetisi hackathon yang diadakan bagi para developer berbakat yang tertarik untuk memecahkan masalah-masalah dalam industri konstruksi, melalui keahlian teknologi, dalam 48 jam.
                                        Melalui acara ini, para peserta akan diedukasi mengenai kasus-kasus aktual yang dihadapi industri konstruksi, serta belajar untuk mengembangkan solusi teknologi dalam waktu singkat di bawah bimbingan mentor-mentor berpengalaman dalam bidang teknologi.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="2">
                                        3. Siapa saja yang boleh mendaftar?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="2">
                                        <Card.Body>
                                            <ul>
                                                <li>1. Warga Negara Indonesia (WNI).</li>
                                                <li>2. Pelajar atau Profesional.</li>
                                                <li>3. Peserta mendaftar sebagai tim, dengan anggota tim maksimal 3 (tiga) orang.</li>
                                                <li>4. Memiliki kartu identitas diri yang masih berlaku (Kartu Pelajar/KTP/SIM/Paspor).</li>
                                            </ul>
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="3">
                                        4. Bagaimana cara untuk mendaftar?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="3">
                                        <Card.Body>
                                            Caranya mudah, kamu hanya perlu klik tautan [LINK] dan mengisi informasi data diri pada formulir pendaftaran tersebut.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="4">
                                        5. Saya tidak familiar dengan industri konstruksi, apakah saya boleh ikut?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="4">
                                        <Card.Body>
                                            Saat mengikuti Digital Construction Hack nanti, kamu akan diedukasi mengenai permasalahan-permasalahan yang ada di industri konstruksi. 
                                            Jadi, tentu saja kamu boleh ikut karena semuanya akan diberi pemahaman yang sama.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="5">
                                        6. Saya belum pernah mengikuti hackathon sebelumnya, apakah saya boleh ikut?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="5">
                                        <Card.Body>
                                            Tentu boleh. Digital Construction Hack akan menjadi pengalaman pertama yang luar biasa untukmu.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="6">
                                        7. Apakah saya harus benar-benar ahli untuk ikut hackathon ini?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="6">
                                        <Card.Body>
                                        Kamu tidak harus benar-benar ahli. Jika kamu adalah pemula, Digital Construction Hack akan mengajarimu banyak hal dan membuatmu lebih ahli.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                                <Card>
                                    <Accordion.Toggle as={Card.Header} eventKey="7">
                                        8. Apa keuntungan saya mengikuti hackathon ini?
                                    </Accordion.Toggle>
                                    <Accordion.Collapse eventKey="7">
                                        <Card.Body>
                                        Dengan mengikuti Digital Construction Hack kamu akan belajar mengenai seluk-beluk industri konstruksi di Indonesia, belajar mengembangkan solusi berbasis teknologi, bertemu dengan teman-teman sejawat, serta dibimbing oleh mentor-mentor ahli di bidang teknologi.
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                                
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        )
    }
}

export default ContentSection04
